import { Col, Modal, Row } from "react-bootstrap";
import useClientVulnerability from "../hooks/useClientVulnerability";
import ThemedModal from "../../../utilities/ThemedModal";
import { ErrorMessage, ErrorMessageWrapper } from "../../../messages";
import Skeleton from "react-loading-skeleton";
import GridWrapper from "../../../GridWrapper";
import { FormInput, FormLabel, FormTextArea, RichTextEditor } from "../../../forms";
import React from "react";
import { auto } from "@popperjs/core";
import Button from "../../../buttons";
import { ThemedSpan } from "../../../utilities";

const ClientVulnerabilityModal = ({
    backdrop = 'static',
    cancel,
    centered = true,
    dialogId,
    dismiss,
    masterAccountId,
    proceed,
    show,
    size = "xl",
    ...rest
}) => {
    const { retry, data, dataError, isDataError, clientVulnerabilityData, isDataLoading } = useClientVulnerability({ masterAccountId });
    const onClose = () => proceed(false);
    const onProceed = () => proceed(true);

    if (isDataError) {
        return <ErrorMessageWrapper>
            <ErrorMessage error={dataError} retryCallback={retry} />
        </ErrorMessageWrapper>;
    };

    return (
        <Modal backdrop={backdrop} centered={centered} size={size} show={show} onHide={onClose} {...rest}>
            <ThemedModal.Header closeButton>
                <Modal.Title>Client Vulnerabilities</Modal.Title>
            </ThemedModal.Header>
            {isDataLoading ?
                <Modal.Body>
                    <Skeleton height={30} count={4} />
                </Modal.Body>
                : data ? <>
                    <Modal.Body>
                        <>
                            <div className="row mt-2 mb-4">
                                <div className="d-flex row justify-content-between align-items-center">
                                    <FormLabel className="col-11">
                                        Client Vulnerabilities
                                    </FormLabel>
                                </div>
                                {clientVulnerabilityData.length > 0 ?
                                    <GridWrapper className="d-grid" gridTemplateColumns={"2fr 2fr 2fr 5fr"}>
                                        <div className="col-start-1 d-flex align-items-end">
                                            <FormLabel>
                                                Category
                                            </FormLabel>
                                        </div>
                                        <div className="col-start-2 d-flex align-items-end">
                                            <FormLabel>
                                                Type
                                            </FormLabel>
                                        </div>
                                        <div className="col-start-3 d-flex align-items-end">
                                            <FormLabel>
                                                Client
                                            </FormLabel>
                                        </div>
                                        <div className="col-start-4 d-flex align-items-end">
                                            <FormLabel>
                                                Additional information and how client is impacted
                                            </FormLabel>
                                        </div>

                                        {clientVulnerabilityData.map((clientVulnerability, index) => <React.Fragment key={index}>
                                            <div className="col-start-1">
                                                <FormInput
                                                    readOnly={true}
                                                    value={clientVulnerability.vulnerabilityCategoryText} />
                                            </div>
                                            <div className="col-start-2">
                                                <FormInput
                                                    readOnly={true}
                                                    value={clientVulnerability.vulnerabilityTypeText} />
                                            </div>
                                            <div className="col-start-3">
                                                <FormInput
                                                    readOnly={true}
                                                    value={clientVulnerability.clientName} />
                                            </div>
                                            <div className="col-start-4">
                                                <FormInput
                                                    readOnly={true}
                                                    value={clientVulnerability.additionalInfo} />
                                            </div>
                                        </React.Fragment>)}
                                    </GridWrapper>
                                    : <ThemedSpan className="mt-2">
                                        There are no active client vulnerabilities for this account.
                                    </ThemedSpan>
                                }
                            </div>
                            <Row className="align-items-center mb-2 g-3">
                                <Col sm={12} xl={6}>
                                    <FormLabel>
                                        Have you discussed if the client would like a friend or family member to join meetings?
                                    </FormLabel>
                                </Col>
                                <Col sm={2} xl={1} xxl={1}>
                                    <FormInput
                                        readOnly={true}
                                        value={data.accompaniedMeetingsDiscussed} />
                                </Col>
                                <Col sm={10} xl={5}>
                                    <FormTextArea
                                        readOnly={true}
                                        value={data?.accompaniedMeetingsDiscussedNotes} />
                                </Col>
                            </Row>
                            <Row className="align-items-center">
                                <Col xs={auto} xl={6}>
                                    <FormLabel>
                                        Are special steps needed to address vulnerabilities?
                                    </FormLabel>
                                </Col>
                                <Col xs={auto} xl={1}>
                                    <FormInput
                                        readOnly={true}
                                        value={data.specialStepsRequired} />
                                </Col>
                            </Row>
                            <div className="row my-2">
                                <FormLabel
                                    wrapLabel
                                    className="mt-2"
                                >
                                    Provide a description of any special steps needed, or an explanation of why no steps are necessary
                                </FormLabel>
                                <RichTextEditor
                                    readOnly={true}
                                    disabled={true}
                                    className="mt-0"
                                    defaultValue={data?.specialStepsNotes?.notes} />
                            </div>
                        </>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={onProceed}>Edit Client Vulnerabilities</Button>
                        <Button variant="light" onClick={onClose}>Close</Button>
                    </Modal.Footer></>
                    : <>
                        <Modal.Body>
                            <ThemedSpan>This account has been set as vulnerable but no client vulnerabilities exist.</ThemedSpan>
                            <br />
                            <ThemedSpan>Click <button className="anchor" onClick={onProceed}>here</button> to be redirected to the Fact Find page to create a client vulnerability.</ThemedSpan>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="light" onClick={onClose}>Close</Button>
                        </Modal.Footer>
                    </>
            }
        </Modal>
    )
}

export default ClientVulnerabilityModal;